import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface TransporterSelection {
  id: number;
  name: string;
  isDisabled?: boolean;
  isSelected?: boolean;
}

@Component({
  selector: 'app-tsp-selection',
  standalone: false,
  templateUrl: './tsp-selection.component.html',
  styleUrl: './tsp-selection.component.scss'
})
export class TspSelectionComponent {

  // Full list
  allTransporters: TransporterSelection[] = [];

  shortlistedTransporters: TransporterSelection[] = [];

  // Search filters
  searchAll: string = '';
  searchShortlisted: string = '';

  constructor(
    public dialogRef: MatDialogRef<TspSelectionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { transporters: TransporterSelection[] }
  ) {
    this.allTransporters = data.transporters.map(t => ({
      ...t,
      isSelected: t.isSelected ?? false,
      isDisabled: t.isDisabled ?? false
    }));
  }

  closeDialogWithResult() {
    // transportersList
    this.dialogRef.close(this.shortlistedTransporters);
  }

  closeDialog() {
    this.dialogRef.close();
  }

  // Move selected from left to right
  moveToShortlist() {
    const selected = this.allTransporters.filter(t => t.isSelected && !t.isDisabled);
    selected.forEach(t => {
      this.shortlistedTransporters.push({ ...t });
      t.isDisabled = true;
      t.isSelected = false;
    });
  }

  // Move selected from right to left
  moveToAll() {
    const toRemove = this.shortlistedTransporters.filter(t => t.isSelected);
    this.shortlistedTransporters = this.shortlistedTransporters.filter(t => !t.isSelected);

    toRemove.forEach(t => {
      const original = this.allTransporters.find(o => o.id === t.id);
      if (original) {
        original.isDisabled = false;
        original.isSelected = false;
      }
    });
  }

  // Get filtered transporter lists (based on search terms)
  get filteredAllTransporters() {
    return this.allTransporters.filter(t =>
      t.name.toLowerCase().includes(this.searchAll.toLowerCase())
    );
  }

  get filteredShortlistedTransporters() {
    return this.shortlistedTransporters.filter(t =>
      t.name.toLowerCase().includes(this.searchShortlisted.toLowerCase())
    );
  }
}
